import { Grid, Cell } from './ui/Layout';
import { Skeleton, SkeletonGroup } from '../common/Skeleton/Skeleton.jsx';

/**
 * The trainer dashboard's shape, shown while its data is on the way.
 *
 * Built from the dashboard's own frames -- the .hero panel, the
 * .sm-vital-grid of cards, the feedback box, the tab strip and the two
 * .td-panel columns -- so the layout is the real one and nothing moves
 * when the figures land. Rendered inside .dashboard-wrapper > .td-page by
 * TrainerDashoard.jsx, which is what scopes those frames' styles.
 */

const VITALS = 6;
const TABS = 6;
const ROWS = 4;

const TrainerDashboardSkeleton = () => (
  <SkeletonGroup label="Loading the dashboard">
    <Grid space="md" className="sm-dash-top">
      <Cell xl={5} lg={6}>
        <div className="hero">
          <div className="hero-inner">
            <div className="hero-text lms-skel-stack">
              <Skeleton tone="dark" width="40" />
              <Skeleton tone="dark" shape="title" width="85" />
              <Skeleton tone="dark" width="55" />
              <Skeleton tone="dark" shape="gauge" />
              <Skeleton tone="dark" width="70" />
            </div>
          </div>
        </div>
      </Cell>

      <Cell xl={7} lg={6}>
        <div className="sm-vital-grid">
          {Array.from({ length: VITALS }, (_, i) => (
            <div className="sm-vital" key={i}>
              <Skeleton width="55" />
              <Skeleton shape="figure" width="40" />
              <Skeleton width="70" />
            </div>
          ))}
        </div>
      </Cell>
    </Grid>

    {/* "What your students said" */}
    <section className="ba tfr mfs">
      <header className="ba-head">
        <div className="lms-skel-stack lms-skel-grow">
          <Skeleton shape="title" width="40" />
          <Skeleton width="55" />
        </div>
      </header>
      <div className="lms-skel-row">
        <Skeleton shape="mark" />
        <div className="lms-skel-stack lms-skel-grow">
          <Skeleton width="25" />
          <Skeleton width="70" />
        </div>
      </div>
    </section>

    <div className="td-tabs">
      <div className="td-tabs-strip">
        {Array.from({ length: TABS }, (_, i) => (
          <Skeleton key={i} shape="tab" />
        ))}
      </div>

      <div className="td-tabs-body lms-skel-stack">
        <Skeleton shape="search" />
        <div className="td-duo">
          {[0, 1].map((panel) => (
            <section className="td-panel lms-skel-stack" key={panel}>
              <Skeleton shape="title" width="40" />
              <Skeleton width="70" />
              {Array.from({ length: ROWS }, (_, i) => (
                <Skeleton key={i} shape="row" />
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  </SkeletonGroup>
);

export default TrainerDashboardSkeleton;
